export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "@id": "https://business-training.by/razvitie-personala/individualnyy-plan-razvitiya-sotrudnikov#service",
        "name": "Разработка индивидуальных планов развития сотрудников",
        "description": "Разработка и внедрение индивидуальных планов развития сотрудников: оценка компетенций, цели развития, выбор инструментов, обучение, практика, сопровождение и контроль результата.",
        "provider": { "@id": "https://business-training.by/o-trenere#person" },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "индивидуальный план развития сотрудников, ИПР, развитие компетенций, развитие персонала, кадровый резерв, обучение сотрудников",
        "url": "https://business-training.by/razvitie-personala/individualnyy-plan-razvitiya-sotrudnikov"
      },
      {
        "@type": "WebPage",
        "name": "Индивидуальный план развития сотрудников: как превратить развитие в конкретный план действий",
        "description": "Индивидуальный план развития сотрудников: оценка компетенций, цели развития, обучение, практика и контроль результата. Разработка ИПР для компаний.",
        "url": "https://business-training.by/razvitie-personala/individualnyy-plan-razvitiya-sotrudnikov",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Person",
        "@id": "https://business-training.by/o-trenere#person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер, консультант, фасилитатор, сертифицированный коуч ICU",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что такое индивидуальный план развития сотрудника?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Индивидуальный план развития — это конкретный план действий сотрудника по развитию необходимых компетенций. Он фиксирует, что нужно развивать, зачем, какой уровень требуется, какой уровень сейчас, какие действия должен выполнить сотрудник, кто ему помогает, в какие сроки и как будет оцениваться результат."
            }
          },
          {
            "@type": "Question",
            "name": "Зачем нужен ИПР сотруднику и компании?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Сотруднику ИПР даёт понятную траекторию развития и перспективы внутри компании. Компании он позволяет сделать развитие управляемым: связать обучение с задачами бизнеса, готовить кадровый резерв, адресно развивать сотрудников и контролировать прогресс."
            }
          },
          {
            "@type": "Question",
            "name": "Что должно входить в индивидуальный план развития?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "В ИПР входят цель развития, конкретная компетенция, текущий и желаемый уровни, конкретные действия, инструменты развития (обучение, наставничество, практика, проекты, коучинг), сроки, ответственные и критерии результата, по которым будет понятно, что компетенция развилась."
            }
          },
          {
            "@type": "Question",
            "name": "Как составить ИПР сотрудника?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Составление ИПР начинается с определения задачи развития, затем оценивается текущий уровень, определяется дефицит, формулируется цель, выбираются инструменты, определяются сроки и критерии результата. После этого план сопровождается, а в конце проводится повторная оценка."
            }
          },
          {
            "@type": "Question",
            "name": "Кто должен составлять индивидуальный план развития?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "ИПР формируется совместно: сотрудник отвечает за выполнение действий, руководитель помогает определить приоритеты и создаёт условия для практики, HR/L&D организует систему и инструменты. При необходимости подключаются наставник и тренер или коуч. ИПР, который существует только в HR-системе и не используется руководителем, быстро становится формальным."
            }
          },
          {
            "@type": "Question",
            "name": "Как определить цели развития сотрудника?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Цели развития определяются от задач бизнеса и конкретной роли сотрудника. Сначала понимают, зачем сотруднику развитие, затем оценивают текущий уровень компетенций и определяют разницу между текущим и необходимым уровнем. Цель формулируется как конкретный результат развития, а не как желание «стать лучше»."
            }
          },
          {
            "@type": "Question",
            "name": "Как ИПР связан с оценкой компетенций?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Оценка компетенций показывает, что сотрудник уже умеет и каких компетенций не хватает. Именно эта разница между текущим и желаемым уровнем становится основой ИПР: без оценки план строится на предположениях, а не на объективных данных."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли использовать ИПР после корпоративного обучения?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, это один из самых полезных сценариев. После корпоративного обучения ИПР помогает перенести результаты тренинга в рабочую практику: зафиксировать, что конкретно сотрудник будет применять, в каких ситуациях и как будет оцениваться результат."
            }
          },
          {
            "@type": "Question",
            "name": "Какие инструменты развития можно включить в ИПР?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "В ИПР можно включать обучение, практику, наставничество, развивающие задачи, коучинг, участие в проектах и самостоятельную работу. Инструмент подбирается под конкретную компетенцию и дефицит, а не наоборот: для одной компетенции нужен тренинг, для другой — практика, для третьей — наставничество."
            }
          },
          {
            "@type": "Question",
            "name": "Как оценивать выполнение индивидуального плана развития?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Выполнение ИПР оценивается по заранее определённым критериям результата. Это может быть демонстрация навыка в реальной рабочей ситуации, обратная связь руководителя, выполнение конкретных действий или повторная оценка компетенции, которая показывает, изменился ли её уровень."
            }
          },
          {
            "@type": "Question",
            "name": "Нужен ли ИПР всем сотрудникам?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Не обязательно. ИПР имеет смысл для сотрудников, которых нужно развивать под конкретную задачу: ключевых специалистов, руководителей, сотрудников кадрового резерва или тех, кого готовят к повышению. Создавать формальные планы для всех сотрудников без задачи развития нецелесообразно."
            }
          },
          {
            "@type": "Question",
            "name": "Как использовать ИПР для кадрового резерва?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Для кадрового резерва ИПР строится вокруг компетенций будущей должности. В план включаются развивающие проекты, наставничество, управленческая практика и подготовка к переходу на новую роль. Так сотрудник системно готовится к будущим обязанностям, а компания снижает риски при назначении."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}